export default __webpack_public_path__ + "static/favicon-317043f1a74fd532ac1dea61461cd285.ico";